import React from 'react';
import { Link } from 'react-router-dom';

const Themify = () => {
    return (
        <div className="container-fluid">
        <div className="block-header">
            <div className="row clearfix">
                <div className="col-md-6 col-sm-12">
                    <h1>Themify Icons</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Oculux</Link></li>
                        <li className="breadcrumb-item"><a href="/">Icon</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Themify Icons</li>
                        </ol>
                    </nav>
                </div>            
                <div className="col-md-6 col-sm-12 text-right hidden-xs">
                    <a href="/" className="btn btn-sm btn-primary" title="">Create Campaign</a>
                    <a href="https://themeforest.net/item/oculux-bootstrap-4x-admin-dashboard-clean-modern-ui-kit/23091507" className="btn btn-sm btn-success" title="Themeforest"><i className="icon-basket"></i> Buy Now</a>
                </div>
            </div>
        </div>

        <div className="row clealfix">
            <div className="col-12">

                <div className="card">
                    <div className="header">
                        <h2>Arrows &amp; Direction Icons </h2>
                    </div>
                    <div className="body">
                        <div className="icon-section">
                
                            <div className="icon-container">
                                <span className="ti-arrow-up"></span><span className="icon-name"> ti-arrow-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-right"></span><span className="icon-name"> ti-arrow-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-left"></span><span className="icon-name"> ti-arrow-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-down"></span><span className="icon-name"> ti-arrow-down</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrows-vertical"></span><span className="icon-name"> ti-arrows-vertical</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrows-horizontal"></span><span className="icon-name"> ti-arrows-horizontal</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-angle-up"></span><span className="icon-name"> ti-angle-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-angle-right"></span><span className="icon-name"> ti-angle-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-angle-left"></span><span className="icon-name"> ti-angle-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-angle-down"></span><span className="icon-name"> ti-angle-down</span>
                            </div>	
                            <div className="icon-container">
                                <span className="ti-angle-double-up"></span><span className="icon-name"> ti-angle-double-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-angle-double-right"></span><span className="icon-name"> ti-angle-double-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-angle-double-left"></span><span className="icon-name"> ti-angle-double-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-angle-double-down"></span><span className="icon-name"> ti-angle-double-down</span>
                            </div>					
                            <div className="icon-container">
                                <span className="ti-move"></span><span className="icon-name"> ti-move</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-fullscreen"></span><span className="icon-name"> ti-fullscreen</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-top-right"></span><span className="icon-name"> ti-arrow-top-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-top-left"></span><span className="icon-name"> ti-arrow-top-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-circle-up"></span><span className="icon-name"> ti-arrow-circle-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-circle-right"></span><span className="icon-name"> ti-arrow-circle-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-circle-left"></span><span className="icon-name"> ti-arrow-circle-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrow-circle-down"></span><span className="icon-name"> ti-arrow-circle-down</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-arrows-corner"></span><span className="icon-name"> ti-arrows-corner</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-split-v"></span><span className="icon-name"> ti-split-v</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-split-v-alt"></span><span className="icon-name"> ti-split-v-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-split-h"></span><span className="icon-name"> ti-split-h</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hand-point-up"></span><span className="icon-name"> ti-hand-point-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hand-point-right"></span><span className="icon-name"> ti-hand-point-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hand-point-left"></span><span className="icon-name"> ti-hand-point-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hand-point-down"></span><span className="icon-name"> ti-hand-point-down</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-back-right"></span><span className="icon-name"> ti-back-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-back-left"></span><span className="icon-name"> ti-back-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-exchange-vertical"></span><span className="icon-name"> ti-exchange-vertical</span>
                            </div>
                
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="header">
                        <h2>Web App Icons</h2>
                    </div>
                    <div className="body">
                        <div className="icon-section">

                            <div className="icon-container">
                                <span className="ti-wand"></span><span className="icon-name"> ti-wand</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-save"></span><span className="icon-name"> ti-save</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-save-alt"></span><span className="icon-name"> ti-save-alt</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-direction"></span><span className="icon-name"> ti-direction</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-direction-alt"></span><span className="icon-name"> ti-direction-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-user"></span><span className="icon-name"> ti-user</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-link"></span><span className="icon-name"> ti-link</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-unlink"></span><span className="icon-name"> ti-unlink</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-trash"></span><span className="icon-name"> ti-trash</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-target"></span><span className="icon-name"> ti-target</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-tag"></span><span className="icon-name"> ti-tag</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-desktop"></span><span className="icon-name"> ti-desktop</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-tablet"></span><span className="icon-name"> ti-tablet</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-mobile"></span><span className="icon-name"> ti-mobile</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-email"></span><span className="icon-name"> ti-email</span>
                            </div>	
                            <div className="icon-container">
                                <span className="ti-star"></span><span className="icon-name"> ti-star</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-spray"></span><span className="icon-name"> ti-spray</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-signal"></span><span className="icon-name"> ti-signal</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shopping-cart"></span><span className="icon-name"> ti-shopping-cart</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shopping-cart-full"></span><span className="icon-name"> ti-shopping-cart-full</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-settings"></span><span className="icon-name"> ti-settings</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-search"></span><span className="icon-name"> ti-search</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-zoom-in"></span><span className="icon-name"> ti-zoom-in</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-zoom-out"></span><span className="icon-name"> ti-zoom-out</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-cut"></span><span className="icon-name"> ti-cut</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-ruler"></span><span className="icon-name"> ti-ruler</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-ruler-alt-2"></span><span className="icon-name"> ti-ruler-alt-2</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-ruler-pencil"></span><span className="icon-name"> ti-ruler-pencil</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-ruler-alt"></span><span className="icon-name"> ti-ruler-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bookmark"></span><span className="icon-name"> ti-bookmark</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bookmark-alt"></span><span className="icon-name"> ti-bookmark-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-reload"></span><span className="icon-name"> ti-reload</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-plus"></span><span className="icon-name"> ti-plus</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-minus"></span><span className="icon-name"> ti-minus</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-close"></span><span className="icon-name"> ti-close</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-pin"></span><span className="icon-name"> ti-pin</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-pencil"></span><span className="icon-name"> ti-pencil</span>
                            </div>
                                    
                                <div className="icon-container">
                                <span className="ti-pencil-alt"></span><span className="icon-name"> ti-pencil-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-paint-roller"></span><span className="icon-name"> ti-paint-roller</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-paint-bucket"></span><span className="icon-name"> ti-paint-bucket</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-na"></span><span className="icon-name"> ti-na</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-medall"></span><span className="icon-name"> ti-medall</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-medall-alt"></span><span className="icon-name"> ti-medall-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-marker"></span><span className="icon-name"> ti-marker</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-marker-alt"></span><span className="icon-name"> ti-marker-alt</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-lock"></span><span className="icon-name"> ti-lock</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-unlock"></span><span className="icon-name"> ti-unlock</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-location-arrow"></span><span className="icon-name"> ti-location-arrow</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout"></span><span className="icon-name"> ti-layout</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layers"></span><span className="icon-name"> ti-layers</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layers-alt"></span><span className="icon-name"> ti-layers-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-key"></span><span className="icon-name"> ti-key</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-image"></span><span className="icon-name"> ti-image</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-heart"></span><span className="icon-name"> ti-heart</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-heart-broken"></span><span className="icon-name"> ti-heart-broken</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hand-stop"></span><span className="icon-name"> ti-hand-stop</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hand-open"></span><span className="icon-name"> ti-hand-open</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hand-drag"></span><span className="icon-name"> ti-hand-drag</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-flag"></span><span className="icon-name"> ti-flag</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-flag-alt"></span><span className="icon-name"> ti-flag-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-flag-alt-2"></span><span className="icon-name"> ti-flag-alt-2</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-eye"></span><span className="icon-name"> ti-eye</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-import"></span><span className="icon-name"> ti-import</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-export"></span><span className="icon-name"> ti-export</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-cup"></span><span className="icon-name"> ti-cup</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-crown"></span><span className="icon-name"> ti-crown</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-comments"></span><span className="icon-name"> ti-comments</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-comment"></span><span className="icon-name"> ti-comment</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-comment-alt"></span><span className="icon-name"> ti-comment-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-thought"></span><span className="icon-name"> ti-thought</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-clip"></span><span className="icon-name"> ti-clip</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-check"></span><span className="icon-name"> ti-check</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-check-box"></span><span className="icon-name"> ti-check-box</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-camera"></span><span className="icon-name"> ti-camera</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-announcement"></span><span className="icon-name"> ti-announcement</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-brush"></span><span className="icon-name"> ti-brush</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-brush-alt"></span><span className="icon-name"> ti-brush-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-palette"></span><span className="icon-name"> ti-palette</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-briefcase"></span><span className="icon-name"> ti-briefcase</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bolt"></span><span className="icon-name"> ti-bolt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bolt-alt"></span><span className="icon-name"> ti-bolt-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-blackboard"></span><span className="icon-name"> ti-blackboard</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bag"></span><span className="icon-name"> ti-bag</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-world"></span><span className="icon-name"> ti-world</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-wheelchair"></span><span className="icon-name"> ti-wheelchair</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-car"></span><span className="icon-name"> ti-car</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-truck"></span><span className="icon-name"> ti-truck</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-timer"></span><span className="icon-name"> ti-timer</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-ticket"></span><span className="icon-name"> ti-ticket</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-thumb-up"></span><span className="icon-name"> ti-thumb-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-thumb-down"></span><span className="icon-name"> ti-thumb-down</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-stats-up"></span><span className="icon-name"> ti-stats-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-stats-down"></span><span className="icon-name"> ti-stats-down</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shine"></span><span className="icon-name"> ti-shine</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shift-right"></span><span className="icon-name"> ti-shift-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shift-left"></span><span className="icon-name"> ti-shift-left</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-shift-right-alt"></span><span className="icon-name"> ti-shift-right-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shift-left-alt"></span><span className="icon-name"> ti-shift-left-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shield"></span><span className="icon-name"> ti-shield</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-notepad"></span><span className="icon-name"> ti-notepad</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-server"></span><span className="icon-name"> ti-server</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-pulse"></span><span className="icon-name"> ti-pulse</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-printer"></span><span className="icon-name"> ti-printer</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-power-off"></span><span className="icon-name"> ti-power-off</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-plug"></span><span className="icon-name"> ti-plug</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-pie-chart"></span><span className="icon-name"> ti-pie-chart</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-panel"></span><span className="icon-name"> ti-panel</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-package"></span><span className="icon-name"> ti-package</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-music"></span><span className="icon-name"> ti-music</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-music-alt"></span><span className="icon-name"> ti-music-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-mouse"></span><span className="icon-name"> ti-mouse</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-mouse-alt"></span><span className="icon-name"> ti-mouse-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-money"></span><span className="icon-name"> ti-money</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-microphone"></span><span className="icon-name"> ti-microphone</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-menu"></span><span className="icon-name"> ti-menu</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-menu-alt"></span><span className="icon-name"> ti-menu-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-map"></span><span className="icon-name"> ti-map</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-map-alt"></span><span className="icon-name"> ti-map-alt</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-location-pin"></span><span className="icon-name"> ti-location-pin</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-light-bulb"></span><span className="icon-name"> ti-light-bulb</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-info"></span><span className="icon-name"> ti-info</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-infinite"></span><span className="icon-name"> ti-infinite</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-id-badge"></span><span className="icon-name"> ti-id-badge</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-hummer"></span><span className="icon-name"> ti-hummer</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-home"></span><span className="icon-name"> ti-home</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-help"></span><span className="icon-name"> ti-help</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-headphone"></span><span className="icon-name"> ti-headphone</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-harddrives"></span><span className="icon-name"> ti-harddrives</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-harddrive"></span><span className="icon-name"> ti-harddrive</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-gift"></span><span className="icon-name"> ti-gift</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-game"></span><span className="icon-name"> ti-game</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-filter"></span><span className="icon-name"> ti-filter</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-files"></span><span className="icon-name"> ti-files</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-file"></span><span className="icon-name"> ti-file</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-zip"></span><span className="icon-name"> ti-zip</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-folder"></span><span className="icon-name"> ti-folder</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-envelope"></span><span className="icon-name"> ti-envelope</span>
                            </div>
                
                
                            <div className="icon-container">
                                <span className="ti-dashboard"></span><span className="icon-name"> ti-dashboard</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-cloud"></span><span className="icon-name"> ti-cloud</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-cloud-up"></span><span className="icon-name"> ti-cloud-up</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-cloud-down"></span><span className="icon-name"> ti-cloud-down</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-clipboard"></span><span className="icon-name"> ti-clipboard</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-calendar"></span><span className="icon-name"> ti-calendar</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-book"></span><span className="icon-name"> ti-book</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bell"></span><span className="icon-name"> ti-bell</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-basketball"></span><span className="icon-name"> ti-basketball</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bar-chart"></span><span className="icon-name"> ti-bar-chart</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-bar-chart-alt"></span><span className="icon-name"> ti-bar-chart-alt</span>
                            </div>
                
                
                            <div className="icon-container">
                                <span className="ti-archive"></span><span className="icon-name"> ti-archive</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-anchor"></span><span className="icon-name"> ti-anchor</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-alert"></span><span className="icon-name"> ti-alert</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-alarm-clock"></span><span className="icon-name"> ti-alarm-clock</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-agenda"></span><span className="icon-name"> ti-agenda</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-write"></span><span className="icon-name"> ti-write</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-wallet"></span><span className="icon-name"> ti-wallet</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-video-clapper"></span><span className="icon-name"> ti-video-clapper</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-video-camera"></span><span className="icon-name"> ti-video-camera</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-vector"></span><span className="icon-name"> ti-vector</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-support"></span><span className="icon-name"> ti-support</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-stamp"></span><span className="icon-name"> ti-stamp</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-slice"></span><span className="icon-name"> ti-slice</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-shortcode"></span><span className="icon-name"> ti-shortcode</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-receipt"></span><span className="icon-name"> ti-receipt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-pin2"></span><span className="icon-name"> ti-pin2</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-pin-alt"></span><span className="icon-name"> ti-pin-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-pencil-alt2"></span><span className="icon-name"> ti-pencil-alt2</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-eraser"></span><span className="icon-name"> ti-eraser</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-more"></span><span className="icon-name"> ti-more</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-more-alt"></span><span className="icon-name"> ti-more-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-microphone-alt"></span><span className="icon-name"> ti-microphone-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-magnet"></span><span className="icon-name"> ti-magnet</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-line-double"></span><span className="icon-name"> ti-line-double</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-line-dotted"></span><span className="icon-name"> ti-line-dotted</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-line-dashed"></span><span className="icon-name"> ti-line-dashed</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-ink-pen"></span><span className="icon-name"> ti-ink-pen</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-info-alt"></span><span className="icon-name"> ti-info-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-help-alt"></span><span className="icon-name"> ti-help-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-headphone-alt"></span><span className="icon-name"> ti-headphone-alt</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-gallery"></span><span className="icon-name"> ti-gallery</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-face-smile"></span><span className="icon-name"> ti-face-smile</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-face-sad"></span><span className="icon-name"> ti-face-sad</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-credit-card"></span><span className="icon-name"> ti-credit-card</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-comments-smiley"></span><span className="icon-name"> ti-comments-smiley</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-time"></span><span className="icon-name"> ti-time</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-share"></span><span className="icon-name"> ti-share</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-share-alt"></span><span className="icon-name"> ti-share-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-rocket"></span><span className="icon-name"> ti-rocket</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-new-window"></span><span className="icon-name"> ti-new-window</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-rss"></span><span className="icon-name"> ti-rss</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-rss-alt"></span><span className="icon-name"> ti-rss-alt</span>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="header">
                        <h2>Control Icons</h2>
                    </div>
                    <div className="body">
                        <div className="icon-section">
                            <div className="icon-container">
                                <span className="ti-control-stop"></span><span className="icon-name"> ti-control-stop</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-shuffle"></span><span className="icon-name"> ti-control-shuffle</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-play"></span><span className="icon-name"> ti-control-play</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-pause"></span><span className="icon-name"> ti-control-pause</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-forward"></span><span className="icon-name"> ti-control-forward</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-backward"></span><span className="icon-name"> ti-control-backward</span>
                            </div>	
                            <div className="icon-container">
                                <span className="ti-volume"></span><span className="icon-name"> ti-volume</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-skip-forward"></span><span className="icon-name"> ti-control-skip-forward</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-skip-backward"></span><span className="icon-name"> ti-control-skip-backward</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-record"></span><span className="icon-name"> ti-control-record</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-control-eject"></span><span className="icon-name"> ti-control-eject</span>
                            </div>			
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="header">
                        <h2>Text Editor</h2>
                    </div>
                    <div className="body">
                        <div className="icon-section">

                            <div className="icon-container">
                                <span className="ti-paragraph"></span><span className="icon-name"> ti-paragraph</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-uppercase"></span><span className="icon-name"> ti-uppercase</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-underline"></span><span className="icon-name"> ti-underline</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-text"></span><span className="icon-name"> ti-text</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-Italic"></span><span className="icon-name"> ti-Italic</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-smallcap"></span><span className="icon-name"> ti-smallcap</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-list"></span><span className="icon-name"> ti-list</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-list-ol"></span><span className="icon-name"> ti-list-ol</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-align-right"></span><span className="icon-name"> ti-align-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-align-left"></span><span className="icon-name"> ti-align-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-align-justify"></span><span className="icon-name"> ti-align-justify</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-align-center"></span><span className="icon-name"> ti-align-center</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-quote-right"></span><span className="icon-name"> ti-quote-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-quote-left"></span><span className="icon-name"> ti-quote-left</span>
                            </div>
                
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="header">
                        <h2>Layout Icons</h2>
                    </div>
                    <div className="body">
                        <div className="icon-section">
                            <div className="icon-container">
                                <span className="ti-layout-width-full"></span><span className="icon-name"> ti-layout-width-full</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-width-default"></span><span className="icon-name"> ti-layout-width-default</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-width-default-alt"></span><span className="icon-name"> ti-layout-width-default-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-tab"></span><span className="icon-name"> ti-layout-tab</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-tab-window"></span><span className="icon-name"> ti-layout-tab-window</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-tab-v"></span><span className="icon-name"> ti-layout-tab-v</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-tab-min"></span><span className="icon-name"> ti-layout-tab-min</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-slider"></span><span className="icon-name"> ti-layout-slider</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-slider-alt"></span><span className="icon-name"> ti-layout-slider-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-sidebar-right"></span><span className="icon-name"> ti-layout-sidebar-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-sidebar-none"></span><span className="icon-name"> ti-layout-sidebar-none</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-sidebar-left"></span><span className="icon-name"> ti-layout-sidebar-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-placeholder"></span><span className="icon-name"> ti-layout-placeholder</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-menu"></span><span className="icon-name"> ti-layout-menu</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-menu-v"></span><span className="icon-name"> ti-layout-menu-v</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-menu-separated"></span><span className="icon-name"> ti-layout-menu-separated</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-menu-full"></span><span className="icon-name"> ti-layout-menu-full</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-right"></span><span className="icon-name"> ti-layout-media-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-right-alt"></span><span className="icon-name"> ti-layout-media-right-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-overlay"></span><span className="icon-name"> ti-layout-media-overlay</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-overlay-alt"></span><span className="icon-name"> ti-layout-media-overlay-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-overlay-alt-2"></span><span className="icon-name"> ti-layout-media-overlay-alt-2</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-left"></span><span className="icon-name"> ti-layout-media-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-left-alt"></span><span className="icon-name"> ti-layout-media-left-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-center"></span><span className="icon-name"> ti-layout-media-center</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-media-center-alt"></span><span className="icon-name"> ti-layout-media-center-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-list-thumb"></span><span className="icon-name"> ti-layout-list-thumb</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-list-thumb-alt"></span><span className="icon-name"> ti-layout-list-thumb-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-list-post"></span><span className="icon-name"> ti-layout-list-post</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-list-large-image"></span><span className="icon-name"> ti-layout-list-large-image</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-line-solid"></span><span className="icon-name"> ti-layout-line-solid</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-grid4"></span><span className="icon-name"> ti-layout-grid4</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-grid3"></span><span className="icon-name"> ti-layout-grid3</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-grid2"></span><span className="icon-name"> ti-layout-grid2</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-grid2-thumb"></span><span className="icon-name"> ti-layout-grid2-thumb</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-cta-right"></span><span className="icon-name"> ti-layout-cta-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-cta-left"></span><span className="icon-name"> ti-layout-cta-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-cta-center"></span><span className="icon-name"> ti-layout-cta-center</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-cta-btn-right"></span><span className="icon-name"> ti-layout-cta-btn-right</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-cta-btn-left"></span><span className="icon-name"> ti-layout-cta-btn-left</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-column4"></span><span className="icon-name"> ti-layout-column4</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-column3"></span><span className="icon-name"> ti-layout-column3</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-column2"></span><span className="icon-name"> ti-layout-column2</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-accordion-separated"></span><span className="icon-name"> ti-layout-accordion-separated</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-accordion-merged"></span><span className="icon-name"> ti-layout-accordion-merged</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-accordion-list"></span><span className="icon-name"> ti-layout-accordion-list</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-widgetized"></span><span className="icon-name"> ti-widgetized</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-widget"></span><span className="icon-name"> ti-widget</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-widget-alt"></span><span className="icon-name"> ti-widget-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-view-list"></span><span className="icon-name"> ti-view-list</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-view-list-alt"></span><span className="icon-name"> ti-view-list-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-view-grid"></span><span className="icon-name"> ti-view-grid</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-upload"></span><span className="icon-name"> ti-upload</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-download"></span><span className="icon-name"> ti-download</span>
                            </div>	
                            <div className="icon-container">
                                <span className="ti-loop"></span><span className="icon-name"> ti-loop</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-sidebar-2"></span><span className="icon-name"> ti-layout-sidebar-2</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-grid4-alt"></span><span className="icon-name"> ti-layout-grid4-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-grid3-alt"></span><span className="icon-name"> ti-layout-grid3-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-grid2-alt"></span><span className="icon-name"> ti-layout-grid2-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-column4-alt"></span><span className="icon-name"> ti-layout-column4-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-column3-alt"></span><span className="icon-name"> ti-layout-column3-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-layout-column2-alt"></span><span className="icon-name"> ti-layout-column2-alt</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="header">
                        <h2>Brand Icons</h2>
                    </div>
                    <div className="body">
                        <div className="icon-section">
                
                            <div className="icon-container">
                                <span className="ti-flickr"></span><span className="icon-name"> ti-flickr</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-flickr-alt"></span><span className="icon-name"> ti-flickr-alt</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-instagram"></span><span className="icon-name"> ti-instagram</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-google"></span><span className="icon-name"> ti-google</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-github"></span><span className="icon-name"> ti-github</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-facebook"></span><span className="icon-name"> ti-facebook</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-dropbox"></span><span className="icon-name"> ti-dropbox</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-dropbox-alt"></span><span className="icon-name"> ti-dropbox-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-dribbble"></span><span className="icon-name"> ti-dribbble</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-apple"></span><span className="icon-name"> ti-apple</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-android"></span><span className="icon-name"> ti-android</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-yahoo"></span><span className="icon-name"> ti-yahoo</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-trello"></span><span className="icon-name"> ti-trello</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-stack-overflow"></span><span className="icon-name"> ti-stack-overflow</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-soundcloud"></span><span className="icon-name"> ti-soundcloud</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-sharethis"></span><span className="icon-name"> ti-sharethis</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-sharethis-alt"></span><span className="icon-name"> ti-sharethis-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-reddit"></span><span className="icon-name"> ti-reddit</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-microsoft"></span><span className="icon-name"> ti-microsoft</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-microsoft-alt"></span><span className="icon-name"> ti-microsoft-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-linux"></span><span className="icon-name"> ti-linux</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-jsfiddle"></span><span className="icon-name"> ti-jsfiddle</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-joomla"></span><span className="icon-name"> ti-joomla</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-html5"></span><span className="icon-name"> ti-html5</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-css3"></span><span className="icon-name"> ti-css3</span>
                            </div>	
                            <div className="icon-container">
                                <span className="ti-drupal"></span><span className="icon-name"> ti-drupal</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-wordpress"></span><span className="icon-name"> ti-wordpress</span>
                            </div>		
                            <div className="icon-container">
                                <span className="ti-tumblr"></span><span className="icon-name"> ti-tumblr</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-tumblr-alt"></span><span className="icon-name"> ti-tumblr-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-skype"></span><span className="icon-name"> ti-skype</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-youtube"></span><span className="icon-name"> ti-youtube</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-vimeo"></span><span className="icon-name"> ti-vimeo</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-vimeo-alt"></span><span className="icon-name"> ti-vimeo-alt</span>
                            </div>			
                            <div className="icon-container">
                                <span className="ti-twitter"></span><span className="icon-name"> ti-twitter</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-twitter-alt"></span><span className="icon-name"> ti-twitter-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-linkedin"></span><span className="icon-name"> ti-linkedin</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-pinterest"></span><span className="icon-name"> ti-pinterest</span>
                            </div>
                
                            <div className="icon-container">
                                <span className="ti-pinterest-alt"></span><span className="icon-name"> ti-pinterest-alt</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-themify-logo"></span><span className="icon-name"> ti-themify-logo</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-themify-favicon"></span><span className="icon-name"> ti-themify-favicon</span>
                            </div>
                            <div className="icon-container">
                                <span className="ti-themify-favicon-alt"></span><span className="icon-name"> ti-themify-favicon-alt</span>
                            </div>
                
                        </div>
                    </div>
                </div>

            </div>
        </div>
        
    </div>
   );

}
export default Themify
